export class CookieConsentConst {
  public static readonly CookieKey = 'cookieconsent_status';
  public static readonly Allow = 'allow';
  public static readonly Deny = 'deny';
}
